var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_setup.answers),function(answer,index){return _c('div',{key:index,staticClass:"mt-2 mb-4"},[_c('h5',{staticClass:"heading5 heading5--secondary"},[_vm._v(_vm._s(answer.field.name))]),_c(_setup.CustomFieldValue,{attrs:{"field":answer.field,"init-value":answer.value,"editable":false}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }